export default __webpack_public_path__ + "static/media/5loyalty-white.5fc839f4.svg";